import { getErrorStatusCode } from './auth-error-handler'

/** Guide page for accounts that cannot use the dealer back-office (not a member, or no DEALER role). */
export const DEALER_ACCESS_PATH = '/dealer-access'

/**
 * The login was valid at the provider but this account cannot use the dealer back-office:
 * the social account has no BOLTB account (login API 404) or the account lacks the DEALER role.
 * Both go to the same guide page (09-30 decision) instead of a generic login error.
 */
export function isDealerAccessDenied(error: unknown): boolean {
  if (error instanceof Error && error.message === 'DEALER_ROLE_REQUIRED') return true
  const cause: unknown = error instanceof Error && 'cause' in error ? error.cause : error
  return getErrorStatusCode(cause) === 404
}

/**
 * Leaves the login flow for the guide page. Refine's useLogin only navigates on success and shows
 * an error toast on failure, so this replaces the location and never settles — no toast flashes.
 */
export function redirectToDealerAccess(): Promise<never> {
  window.location.replace(DEALER_ACCESS_PATH)
  return new Promise<never>(() => {})
}
